import { type IDropdownItem } from 'shared/ui'
import { type IInboxCombine } from 'entities/Inbox'
import type { IEntitiesStore } from 'entities/EntitiesExport'

const typeRename = 'rename'

type IActionRename = {
  inbox: IInboxCombine
  item: IDropdownItem
  entities: IEntitiesStore
}

export const menuRename = (): IDropdownItem => {
  return {
    id: typeRename,
    iconL: 'edit',
    label: 'Rename',
  }
}

export const actionRename = async ({ inbox, item, entities }: IActionRename) => {
  if (item.id === typeRename) {
    entities.inboxesStore.handleRenameGroup(inbox, true)
  }
}
